module.exports = __webpack_public_path__ + "static/media/roadmap.1c53955a.png";